module.exports = "https://r.nearpod.com/assets/media/image/bbc-transparent-badff38bb86a307f51ef5bb7cfc715b1.svg";